module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "kbx-content",
    attrs: {
      "klickbox-edit-item": "progress",
      "klickbox-edit-label": _vm.$t('edit.canvas.progressbar')
    }
  }, [_c('item-done'), _vm._v(" "), _c('item-active'), _vm._v(" "), _c('item-default'), _vm._v(" "), _c('item-mask')], 1)])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-580eed38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/progressbar/numeric/Main.vue
 ** module id = 835
 ** module chunks = 1
 **/